import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

const getReport = async (endpoint) => {
  const response = await $api.get(endpoint);
  return ResponseChecker(defaultMessages, response);
};

export const GetRegionEmployees = (option) =>
  getReport(Endpoints.CrmCustomerReport.RegionEmployees(option));

export const GetTagGroups = (option) =>
  getReport(Endpoints.CrmCustomerReport.TagGroups(option));

export const GetProductBrands = (option) =>
  getReport(Endpoints.CrmCustomerReport.ProductBrands(option));

export const GetLeadPlatforms = (option) =>
  getReport(Endpoints.CrmCustomerReport.LeadPlatforms(option));

export const GetReactions = (option) =>
  getReport(Endpoints.CrmCustomerReport.Reactions(option));

export const GetReactionEmployees = (option) =>
  getReport(Endpoints.CrmCustomerReport.ReactionEmployees(option));

export default {
  GetRegionEmployees,
  GetTagGroups,
  GetProductBrands,
  GetLeadPlatforms,
  GetReactions,
  GetReactionEmployees,
};
